module.exports = __webpack_public_path__ + "img/science_app_8.643140a5.jpg";